import React from 'react';
import i18n from "../i18n";
import routes from "../routes";
import * as api from "../utils/api";
import Loading from "../components/Loading";
import FileChooseButton from "../components/FileChooseButton";
import HomeButton from "../components/HomeButton";
import Share from "../components/Share";
import MessageModal from "../components/MessageModal";
import AppContext from "../contexts/AppContext";
import * as creativeUtils from "../utils/creative";
import {getLocationQueryObject} from "../utils/text";
import {hitEvent, hits, logEvent, userEvents} from "../utils/log";
import Modal from "../components/Modal";
import * as webviewUtils from "../utils/webview";
import ImageView from "../components/ImageView";

const FETCH_INTERVAL = 1000;

export default class ResultPage extends React.Component {

  constructor(props) {
    super(props);

    this.state = {
      isLoading: true,
      photo: null,
      creatives: [],
      creative: null,
      creativeId: 0,
    };

    this.fetchResult = this.fetchResult.bind(this);
    this.handleResultFetched = this.handleResultFetched.bind(this);
    this.handleShare = this.handleShare.bind(this);
    this.handleFileSelected = this.handleFileSelected.bind(this);
    this.handleDownloadButtonClick = this.handleDownloadButtonClick.bind(this);

    this.fecthTimer = null;
  }

  componentDidMount() {
    this.fetchResult();
  }

  componentWillUnmount() {
    clearTimeout(this.fecthTimer)
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.match.params.hash !== prevProps.match.params.hash) {
      this.setState({
        isLoading: true
      }, () => {
        this.fetchResult();
      });
    }
  }

  fetchResult() {
    api.fetchPhotoByHash(this.props.match.params.hash)
      .then(this.handleResultFetched)
      .catch((err) => {
        console.error(err);
        this.props.history.replace(routes.ERROR);
      });
  }

  handleResultFetched(res) {
    const query = getLocationQueryObject();
    const isNewResult = this.state.photo === null || this.state.photo.id !== res.photo.id;
    const nextState = {
      isLoading: false,
      photo: res.photo,
      creatives: res.creatives,
    };

    if (isNewResult) {
      nextState.creativeId = res.creatives.filter((c) => c.template.is_tab)[0].id;

      logEvent(userEvents.PAGE_RESULT, {
        photo_id: nextState.photo.id,
        is_owner: nextState.photo.is_owner,
        ref: nextState.photo.is_owner ? undefined : (query.ref || "unspecified")
      });
    }

    let cb = undefined;

    if (nextState.creatives.filter(creativeUtils.creativeIsProcessing).length > 0) {
      cb = () => {
        this.fecthTimer = setTimeout(this.fetchResult, FETCH_INTERVAL);
      };
    }

    this.setState(nextState, cb);
  }

  handleShare(provider) {
    const creative = this.state.creatives.find((c) => c.id === this.state.creativeId);

    hitEvent(hits.SHARE);
    logEvent(userEvents.SHARE, {
      photo_id: this.state.photo.id,
      creative_id: creative.id,
      template_id: creative.template.id,
      provider
    });

    api.logPhotoShare(this.state.photo.id, provider);
  }

  handleFileSelected(file) {
    hitEvent(hits.PHOTO_SELECT);
    logEvent(userEvents.PHOTO_SELECT, {page: "result"});

    this.props.history.push(routes.CREATE, {file});
  }

  handleDownloadButtonClick(e) {
    const creative = this.state.creatives.find((c) => c.id === this.state.creativeId);

    hitEvent(hits.DOWNLOAD);
    logEvent(userEvents.DOWNLOAD, {
      photo_id: this.state.photo.id,
      creative_id: creative.id,
      template_id: creative.template.id,
    });

    this.context.pushModal(<DownloadModal key="ResultPage-DownloadModal" />);

    if (window.clientConfig.isWebview) {
      webviewUtils.webviewShareDownload(creative.file.url);
    } else {
      const downloadUrl = new URL(this.state.photo.download_url);
      downloadUrl.searchParams.append("creative_id", creative.id);
      window.location.href = downloadUrl.toString();
    }
  }

  handleCreativeSelect = (creative) => {
    this.setState({creativeId: creative.id});
  };

  render() {
    if (this.state.isLoading) {
      const photo = this.props.location.state
        && this.props.location.state.photo
        && this.props.location.state.photo.file
        && this.props.location.state.photo.file.url;

      return <Loading image={photo} />;
    }

    const creative = this.state.creatives.find((c) => c.id === this.state.creativeId);
    const creativeIsProcessing = creativeUtils.creativeIsProcessing(creative);
    const isOwner = this.state.photo.is_owner;
    const isGuest = !isOwner;

    return <main className="collage-page">
      <div className="container">
        <HomeButton page={"result"} />
        <h1 hidden={true}
            className="main-title"
            dangerouslySetInnerHTML={{__html: i18n.t("landing__title")}} />
      </div>
      <div className="collage-page-content">
        {/* <h2 hidden={isGuest} children={i18n.t("collage__title")} /> */}

        {/* <div className="tabs-container" hidden={this.state.creatives.length < 2}>
          <button
            className={this.state.tabIndex === 0 ? 'active-tab' : ''}
            onClick={() => this.setState({tabIndex: 0})}
            children={i18n.t("collage__tab_image")} />
          <button
            className={this.state.tabIndex === 1 ? 'active-tab' : ''}
            onClick={() => this.setState({tabIndex: 1})}
            children={i18n.t("collage__tab_video")} />
        </div> */}

        <div className="templates-container">
          <div className="container">
            {this.state.creatives.filter((creative) => !!creative.template.is_tab).map((creative) => {
              const classNames = [
                "btn-choice-template",
                "btn-choice-template--" + creative.template.id,
              ];

              (this.state.creativeId === creative.id) && classNames.push("active");

              return <button
                key={creative.template.id}
                className={classNames.join(" ")}
                onClick={() => this.handleCreativeSelect(creative)}
              />;
            })}
          </div>
        </div>

        <div className="creative-holder">
          {creativeIsProcessing && <div className="wait-video" />}

          <CreativeView creative={creative} />

          <div className="loader-video">
            <span className="item-loader first-item-loader" />
            <span className="item-loader second-item-loader" />
            <span className="item-loader third-item-loader" />
          </div>
        </div>

        {/* <div className="container" hidden={creativeIsProcessing || isGuest}>
          <Share
            creative={creative}
            downloadUrl={downloadUrl.toString()}
            shareUrl={shareUrl.toString()}
            onShare={this.handleShare} />
        </div> */}

        <div className="btns-container">
          <button
            className="btn-upload-foto"
            children={i18n.t("collage__download")}
            onClick={this.handleDownloadButtonClick} />
        </div>
      </div>

      {/* <div className="container" hidden={false}>
        <p className="collage-page-text" dangerouslySetInnerHTML={{__html: i18n.t("collage__text_guest")}} />
        <FileChooseButton
          onFileSelected={this.handleFileSelected}
          className="btn-upload-foto"
          children={i18n.t("collage__select_photo")} />
      </div> */}

      <svg className="net net2" viewBox="0 0 184 320">
        <g fill="#DFDFE0" fill-rule="nonzero">
          <path d="M183.967 3.473a21495.38 21495.38 0 0 0-13.724 90.99c.143.508.06 1.052-.226 1.495l-33.36 221.747c-.556 3.736-6.296 2.59-5.739-1.13.719-4.705 1.426-9.427 2.122-14.166a2.12 2.12 0 0 1-.8-1.495c-3.807-40.155-38.167-70.453-78.512-69.228a2.489 2.489 0 0 1-.748-.122 2.158 2.158 0 0 1-1.74.609l-22.384 16.529c-3.026 2.242-6.296-2.625-3.27-4.85l24.68-18.18c3.688-14.895 7.219-30.034 7.132-45.434a81.639 81.639 0 0 0-3.67-24.577 61.315 61.315 0 0 0-4.73-11.054 48.66 48.66 0 0 0-4.958-8.152l-41.743-6.257c-3.74-.573-2.591-6.309 1.13-5.753l35.17 5.214A95.026 95.026 0 0 0 81.8 54.61L61.572 27.232c-2.243-3.024 2.627-6.292 4.853-3.25l17.393 23.5.591-.105c.303-.071.619-.071.922 0a169.016 169.016 0 0 0 90.6-30.121l2.244-14.966c.574-3.736 6.313-2.59 5.792 1.182zM162.764 104.77a44.192 44.192 0 0 1-27.585 12.167l4.61 6.274h.312a18.443 18.443 0 0 0 19.515-6.761 1.861 1.861 0 0 1 1.496-.817c.568-3.615 1.12-7.236 1.652-10.863zm-21.828 29.826a15.485 15.485 0 0 1-6.105 9.664l14.82 2.224-8.715-11.888zm-7.513 15.278a24.665 24.665 0 0 1 .747 13.904l15.48-11.419-16.227-2.485zm-5.88 18.719a20.34 20.34 0 0 0 .766-19.484l-14.28-2.138a28.18 28.18 0 0 1 7.584 26.071l5.93-4.45zm.4-25.48c.251-.475.685-.827 1.2-.974a11.036 11.036 0 0 0 7.48-12.931 2.119 2.119 0 0 1 0-.557l-5.531-7.49a19.632 19.632 0 0 1-3.479 10.115 53.903 53.903 0 0 1-10.766 10.15l11.097 1.686zm15.55-14.93 13.08 17.815 3.478-23.534a22.742 22.742 0 0 1-16.558 5.753v-.035zm-10.297 43.452a32.115 32.115 0 0 1 17.028 16.425l4.905-32.52-21.933 16.095zm15.167 24.768a27.816 27.816 0 0 0-19.132-21.466h-.174l-9.601 7.091a50.93 50.93 0 0 1 27.829 25.724c.522-3.476 1.026-6.83 1.548-10.254a2.346 2.346 0 0 1-.47-1.095zm-3.252 17.259a46.946 46.946 0 0 0-28.612-28.157 1.965 1.965 0 0 1-.939-.678L97.35 198.14c20.852 1.058 39.056 14.46 46.247 34.049.87-5.823 1.74-11.628 2.627-17.381a2.051 2.051 0 0 1-1.113-1.217v.07zm-29.794-35.927c5.352-10.569 2.183-23.46-7.462-30.347a1.894 1.894 0 0 1-.8-1.408l-17.515-2.624c12.175 13.748 10.192 32.294 5.514 49.327l20.263-14.948zm-4.714-37.126c3.479-2.676 6.957-5.388 10.036-8.377 5.078-4.78 6.209-9.177 6.226-15.956-.019-.179-.019-.36 0-.539l-12.47-16.964c1.74 16.028-6.363 31.523-20.524 39.247l16.732 2.59zm21.41-27.81a40.014 40.014 0 0 0 31.917-15.642l3.478-23.273a66.116 66.116 0 0 1-49.117 20.249l13.723 18.667zm2.87 177.46a45843.85 45843.85 0 0 0 7.34-48.892 2.016 2.016 0 0 1-.73-1.164c-5.583-23.239-25.359-38.586-49.31-37.717-.19.027-.383.027-.573 0l-33.708 24.872c37.05.87 68.769 26.789 76.982 62.902zm-80.65-145.044a75.254 75.254 0 0 1 6.957 25.203c1.878 17.242-1.461 34.432-5.48 51.187l33.552-24.716c5.618-18.059 10.192-39.316-5.844-53.499a2.103 2.103 0 0 1-.679-1.13l-33.046-4.97a61.188 61.188 0 0 1 4.54 7.925zm-9.184-14.547 40.786 6.152c18.124-6.465 27.95-24.037 23.446-42.826a2.224 2.224 0 0 1 .313-1.738l-23.81-32.26a99.561 99.561 0 0 1-40.735 70.672zM86.966 51.74l28.003 37.908a61.817 61.817 0 0 0 52.474-22.438 2.07 2.07 0 0 1 1.079-.713l6.522-43.366a172.95 172.95 0 0 1-88.078 28.61z"/>
          <path d="M98.741 282.404c.237-.026.476-.026.713 0h.14c.362.033.716.133 1.043.295.5.253.918.645 1.2 1.13.462.457.709 1.089.678 1.738a3.65 3.65 0 0 1-2.383 3.476 3.48 3.48 0 0 1-4.191-1.738 3.474 3.474 0 0 1 2.8-4.901zM89.227 272.045l-.348-.504a2.922 2.922 0 0 1 .792-4.059 2.927 2.927 0 0 1 4.06.791l.349.521a2.918 2.918 0 0 1-2.213 4.608 2.923 2.923 0 0 1-2.64-1.357zM79.609 282.7a1.465 1.465 0 1 1 1.635 2.433 1.465 1.465 0 1 1-1.635-2.433zM37.987 211.524a1.305 1.305 0 0 1-.904-.313c-.3.015-.59-.098-.8-.313a2.797 2.797 0 0 1-.557-3.32 2.592 2.592 0 0 1 3.34-1.06 2.641 2.641 0 0 1-1.079 5.006zM25.69 196.403a3.478 3.478 0 0 1-3.287 3.059c-3.617.226-5.218-5.128-1.843-6.727a3.654 3.654 0 0 1 4.504 1.026c.358.51.552 1.115.557 1.738.065.296.089.6.07.904zM130.518 23.983l-.417-.087a1.462 1.462 0 1 1 .573-2.868h.418a1.505 1.505 0 1 1-.574 2.955zM118.673 19.116a1.74 1.74 0 0 1-1.27-.208 1.357 1.357 0 0 1-1.13-.313 2.936 2.936 0 0 1 2.392-5.218 2.938 2.938 0 0 1 .008 5.74zM127.596 11.364a1.465 1.465 0 1 1-1.635-2.433 1.465 1.465 0 1 1 1.635 2.433zM165.617 20.316a1.46 1.46 0 0 1-1.635-2.416 1.46 1.46 0 0 1 1.635 2.416z"/>
        </g>
      </svg>
    </main>;
  }
}

ResultPage.contextType = AppContext;

function CreativeView({creative, height}) {
  if (!creative.file) {
    return <React.Fragment />;
  }

  if (creative.file.is_video) {
    return <video
      key={creative.file.url}
      style={{maxHeight: height}}
      playsInline muted loop autoPlay controls={false} >
      <source src={creative.file.url} type="video/mp4" />
    </video>;
  }

  return <ImageView image={creative.file} backgrounded />;
}

class DownloadModal extends Modal {

  renderModal() {
    return <div className="modal-container">
      <div className="modal">
        <svg viewBox="0 0 1146 1194">
          <defs>
            <linearGradient id="f0vqudj4dc" x1="15.689%" x2="95.007%" y1="62.766%" y2="47.151%">
              <stop offset="0%" stop-color="#FD5"/>
              <stop offset="22.102%" stop-color="#FF543E"/>
              <stop offset="49.89%" stop-color="#CA38A6"/>
              <stop offset="100%" stop-color="#C837AB"/>
            </linearGradient>
            <linearGradient id="fpdw992tpg" x1="6.731%" x2="93.591%" y1="93.485%" y2="6.619%">
              <stop offset="0%" stop-color="#FD5"/>
              <stop offset="50%" stop-color="#FF543E"/>
              <stop offset="100%" stop-color="#C837AB"/>
            </linearGradient>
            <circle id="i9oat8mwtd" cx="45" cy="45" r="45"/>
            <circle id="qqz7eomytf" cx="60" cy="60" r="60"/>
            <rect id="rfcy3igpna" width="1146" height="1194" x="0" y="0" rx="54"/>
          </defs>
          <g fill="none" fill-rule="evenodd">
            <g>
              <g transform="translate(-48 -507) translate(48 507)">
                  <mask id="p4hp50zg7b" fill="#fff">
                        <use xlinkHref="#rfcy3igpna"/>
                    </mask>
                    <g fill="#FFEB3B" fill-rule="nonzero" mask="url(#p4hp50zg7b)">
                      <path d="M137.687 123.23c-25.746 6.935-19.446-5.412-16.96-24.032-9.254 13.63-22.043 5.551-18.901-6.634C96.78 102.02 86.628 112 75.769 104.782 64.401 97.447 68.755 27.227 0 .007 10.455 6.768 29.255 30.44 2.1 55.354c33.302 1.228 20.653 33.078 12.25 35.287 20.676 2.37 30.905 13.49 24.7 40.329 17.085-9.514 47.52-7.986 37.485 33.94 8.032-19.737 46.195-24.87 41.123 6.177 13.89-17.527 44.435-13.191 51.328 5.914-.35-17.728 22.912-32.449 37.843-21.126-1.048-18.869 21.975-35.732 43.172-34.122-36.275-29.34-83.986-6.143-112.314 1.478z" transform="translate(853 -6)"/>
                    </g>
                    <g fill="#00CE3F" fill-rule="nonzero" mask="url(#p4hp50zg7b)">
                        <path d="M137.687 123.23c-25.746 6.935-19.446-5.412-16.96-24.032-9.254 13.63-22.043 5.551-18.901-6.634C96.78 102.02 86.628 112 75.769 104.782 64.401 97.447 68.755 27.227 0 .007 10.455 6.768 29.255 30.44 2.1 55.354c33.302 1.228 20.653 33.078 12.25 35.287 20.676 2.37 30.905 13.49 24.7 40.329 17.085-9.514 47.52-7.986 37.485 33.94 8.032-19.737 46.195-24.87 41.123 6.177 13.89-17.527 44.435-13.191 51.328 5.914-.35-17.728 22.912-32.449 37.843-21.126-1.048-18.869 21.975-35.732 43.172-34.122-36.275-29.34-83.986-6.143-112.314 1.478z" transform="rotate(-25 1042.61 154.693)"/>
                    </g>
                    <g fill="url(#f0vqudj4dc)" fill-rule="nonzero" mask="url(#p4hp50zg7b)">
                        <path d="M192.762 172.523c-36.045 9.708-27.225-7.577-23.745-33.646-12.955 19.082-30.859 7.772-26.461-9.288-7.063 13.24-21.277 27.212-36.48 17.106C90.162 136.425 96.257 38.118 0 .01c14.637 9.466 40.956 42.606 2.94 77.486 46.623 1.719 28.914 46.308 17.15 49.402 28.946 3.319 43.268 18.885 34.58 56.46 23.92-13.32 66.528-11.181 52.479 47.516 11.244-27.631 64.673-34.818 57.572 8.647 19.445-24.537 62.21-18.467 71.86 8.28-.49-24.82 32.076-45.428 52.98-29.576-1.468-26.416 30.764-50.024 60.44-47.771-50.784-41.075-117.58-8.6-157.24 2.07z" transform="rotate(-25 409.096 -739.917)"/>
                    </g>
                    <g fill="#039BE5" fill-rule="nonzero" mask="url(#p4hp50zg7b)">
                        <path d="M192.762 172.523c-36.045 9.708-27.225-7.577-23.745-33.646-12.955 19.082-30.859 7.772-26.461-9.288-7.063 13.24-21.277 27.212-36.48 17.106C90.162 136.425 96.257 38.118 0 .01c14.637 9.466 40.956 42.606 2.94 77.486 46.623 1.719 28.914 46.308 17.15 49.402 28.946 3.319 43.268 18.885 34.58 56.46 23.92-13.32 66.528-11.181 52.479 47.516 11.244-27.631 64.673-34.818 57.572 8.647 19.445-24.537 62.21-18.467 71.86 8.28-.49-24.82 32.076-45.428 52.98-29.576-1.468-26.416 30.764-50.024 60.44-47.771-50.784-41.075-117.58-8.6-157.24 2.07z" transform="translate(940 286)"/>
                    </g>
                    <g fill="#1877F2" fill-rule="nonzero" mask="url(#p4hp50zg7b)">
                        <path d="M192.762 172.523c-36.045 9.708-27.225-7.577-23.745-33.646-12.955 19.082-30.859 7.772-26.461-9.288-7.063 13.24-21.277 27.212-36.48 17.106C90.162 136.425 96.257 38.118 0 .01c14.637 9.466 40.956 42.606 2.94 77.486 46.623 1.719 28.914 46.308 17.15 49.402 28.946 3.319 43.268 18.885 34.58 56.46 23.92-13.32 66.528-11.181 52.479 47.516 11.244-27.631 64.673-34.818 57.572 8.647 19.445-24.537 62.21-18.467 71.86 8.28-.49-24.82 32.076-45.428 52.98-29.576-1.468-26.416 30.764-50.024 60.44-47.771-50.784-41.075-117.58-8.6-157.24 2.07z" transform="rotate(-60 135.52 132.288)"/>
                    </g>
                    <g mask="url(#p4hp50zg7b)">
                        <g transform="rotate(20 290.834 2633.077)">
                            <mask id="rr6vkygffe" fill="#fff">
                                <use xlinkHref="#i9oat8mwtd"/>
                            </mask>
                            <use fill="#FFEB3B" xlinkHref="#i9oat8mwtd"/>
                            <g mask="url(#rr6vkygffe)">
                                <g fill-rule="nonzero">
                                    <path fill="#FFF" d="M45.752 42.662c2.199-.352 6.789-1.184 6.917-3.4.036-.623-.4-1.177-1.009-1.276v-.002c-6.784-1.138-11.056-8.95-10.397-10.511.475-1.13 2.595-1.567 3.53-1.935 4.473-1.793 2.546-4.86-.096-4.86-1.19 0-2.603 1.29-3.905.683.404-6.87 1.12-11.708-3.738-16.388-6.307-6.065-19.104-5.359-23.47 4.606-1.298 2.956-.8 8.36-.592 11.782-.919.41-2.232-.032-3.14-.466-2.288-1.09-6.202 2.49-.854 4.641 2.317.926 4.51 1.19 3.286 3.723-.133.242-.877 2.089-2.623 4.155-5.033 5.964-9.619 3.526-8.413 6.383v.005c.764 1.817 4.825 2.546 6.788 2.86.54 1.028.148 3.39 1.988 3.39.989 0 2.872-.817 5.821-.313 3.976.677 8.492 9.086 18.486 1.91l.002-.005c2.154-1.547 3.667-2.692 8.248-1.773 3.321.654 2.398-1.679 3.171-3.21z" transform="translate(18 18.75)"/>
                                    <path fill="#212121" stroke="#222121" strokeWidth="1.5" d="M26.773 51.582c.038.006-.074.013-.19.013-3.55 0-5.892-1.685-7.775-3.041-6.878-4.953-9.974 2.566-11.632-4.9-9.508-1.687-7.64-6.376-5.222-6.777 2.786-.47 5.06-2.06 6.856-4.184 1.176-1.392 2.898-4.292 2.687-4.79-.224-.538-2.255-1.06-2.911-1.325-6.762-2.725-1.95-8.447 1.746-6.696.647.311 1.131.443 1.479.495-.206-3.364-.56-8.268.748-11.249C17.87-3.006 35.9-3.08 41.234 9.13c1.313 2.99.952 7.883.746 11.2 1.096-.274 2.32-1.278 4.27-.47 3.048 1.109 3.805 5.223-1.87 7.005-.515.168-1.9.614-2.08 1.042-.262.628 3.244 7.917 9.55 8.974 1.175.195 2.011 1.247 1.942 2.448-.162 2.846-4.335 3.821-7.168 4.325-.415 1.876-.722 3.486-2.793 3.486-3.54-.209-4.664-1.587-8.84 1.42-2.469 1.767-4.898 3.23-8.218 3.022zm6.69-4.689c5.072-3.646 6.307-2.29 10.364-1.997.486 0 .139-.836 1.183-3.25.888-.177 5.906-.883 6.498-2.28h-.003l-.03-.273c-7.55-1.268-10.837-9.014-10.974-9.343-2.24-4.608 3.938-4.57 5.538-6.24.65-.681.184-1.277-.605-1.564-1.34-.556-1.789.596-3.88.692-1.069-.047-1.315-.338-1.927-.585.497-6.986 1.183-11.905-3.35-16.273C30.551.275 18.666.757 14.611 10.027c-1.221 2.779-.674 8.404-.45 12.042-.433.083-1.645 1.351-4.794-.166-.863-.41-3.882 1.006.05 2.593 1.057.424 3.45.877 4.145 2.544C14.63 29.61 9.442 37.89 2.32 39.087v.002l-.038.278c.632 1.506 6.262 2.205 6.486 2.275 1.04 2.503.368 1.062.95 3.07.238.807 2.226-.79 6.32-.078 4.28.728 8.468 8.676 17.426 2.259h0z" transform="translate(18 18.75)"/>
                                </g>
                            </g>
                        </g>
                    </g>
                    <g mask="url(#p4hp50zg7b)">
                        <g>
                            <g transform="translate(481 150)">
                                <mask id="p6l69gelyh" fill="#fff">
                                    <use xlinkHref="#qqz7eomytf"/>
                                </mask>
                                <use fill="#D8D8D8" xlinkHref="#qqz7eomytf"/>
                                <path fill="url(#fpdw992tpg)" fill-rule="nonzero" d="M8 8.428C-1.375 18.166.544 28.51.544 59.936c0 26.097-4.554 52.26 19.277 58.418 7.441 1.914 73.375 1.914 80.806-.01 9.922-2.56 17.995-10.608 19.098-24.64.154-1.96.154-65.542-.005-67.54C118.547 11.217 109.346 2.602 97.222.857 94.443.455 93.887.336 79.63.311 29.062.336 17.977-1.916 8 8.428z" mask="url(#p6l69gelyh)"/>
                            </g>
                            <path fill="#FFF" fill-rule="nonzero" d="M60 24.035c-14.745 0-28.747-1.311-34.095 12.405-2.21 5.664-1.889 13.021-1.889 23.555 0 9.244-.296 17.932 1.889 23.552 5.336 13.724 19.452 12.41 34.088 12.41 14.12 0 28.679 1.468 34.092-12.41 2.213-5.721 1.888-12.969 1.888-23.552 0-14.048.776-23.117-6.042-29.926-6.904-6.899-16.24-6.034-29.946-6.034H60zm-3.224 6.48c30.759-.049 34.673-3.465 32.513 44-.768 16.787-13.56 14.945-29.284 14.945-28.67 0-29.495-.82-29.495-29.48 0-28.994 2.274-29.449 26.266-29.473v.008zm22.433 5.97c-2.383 0-4.316 1.93-4.316 4.313 0 2.382 1.933 4.313 4.316 4.313 2.384 0 4.317-1.931 4.317-4.313 0-2.382-1.933-4.314-4.317-4.314zm-19.208 5.043c-10.205 0-18.478 8.27-18.478 18.467 0 10.198 8.273 18.464 18.478 18.464 10.205 0 18.473-8.266 18.473-18.464 0-10.197-8.268-18.467-18.473-18.467zm0 6.48c15.858 0 15.878 23.974 0 23.974-15.854 0-15.879-23.973 0-23.973z" transform="translate(481 150)"/>
                        </g>
                    </g>
                    <g fill-rule="nonzero" mask="url(#p4hp50zg7b)">
                        <g transform="rotate(-30 308.2 -97.495)">
                            <circle cx="59.573" cy="59.573" r="59.573" fill="#1877F2"/>
                            <path fill="#FFF" d="M74.55 61.905H63.92v38.944H47.814V61.905h-7.66V48.22h7.66v-8.857c0-6.333 3.009-16.25 16.249-16.25l11.93.05v13.284h-8.656c-1.42 0-3.416.71-3.416 3.73v8.056h12.036L74.55 61.905z"/>
                        </g>
                    </g>
                    <g mask="url(#p4hp50zg7b)">
                        <g transform="translate(123 482)">
                            <circle cx="45" cy="45" r="45" fill="#00CE3F"/>
                            <path fill="#FFF" d="M62.687 27.294c-4.697-4.701-10.944-7.291-17.6-7.294-13.712 0-24.873 11.156-24.878 24.87-.002 4.383 1.143 8.662 3.32 12.433L20 70.191l13.189-3.458c3.633 1.981 7.725 3.025 11.889 3.027h.01c13.711 0 24.873-11.158 24.879-24.87.002-6.646-2.583-12.895-7.28-17.596"/>
                            <path fill="#00CE3F" d="M45.088 65.56h-.009c-3.71-.002-7.35-.998-10.524-2.882l-.755-.448-7.827 2.052 2.09-7.628-.492-.782c-2.07-3.291-3.163-7.095-3.162-11.001.005-11.398 9.281-20.67 20.687-20.67 5.523.002 10.715 2.155 14.62 6.062 3.903 3.907 6.052 9.101 6.05 14.625-.005 11.398-9.28 20.671-20.678 20.671"/>
                            <path fill="#FFF" d="M56.43 50.078c-.621-.312-3.677-1.815-4.247-2.022-.57-.208-.984-.311-1.399.31-.414.623-1.606 2.023-1.968 2.437-.363.415-.726.467-1.347.156-.622-.311-2.625-.967-5-3.085-1.847-1.647-3.095-3.682-3.457-4.305-.363-.622-.039-.958.272-1.268.28-.278.622-.726.933-1.089.31-.362.414-.622.621-1.036.207-.415.104-.778-.052-1.09-.155-.31-1.398-3.369-1.916-4.613-.505-1.212-1.017-1.048-1.399-1.067-.362-.018-.777-.022-1.191-.022-.415 0-1.088.156-1.658.778-.57.622-2.176 2.125-2.176 5.184s2.228 6.014 2.539 6.429c.31.414 4.383 6.691 10.619 9.383 1.483.64 2.641 1.023 3.544 1.31 1.489.472 2.844.405 3.915.245 1.195-.178 3.678-1.503 4.196-2.955.518-1.451.518-2.695.363-2.955-.156-.259-.57-.414-1.192-.725"/>
                        </g>
                    </g>
                    <g fill-rule="nonzero" mask="url(#p4hp50zg7b)">
                        <g transform="translate(1008 405)">
                            <circle cx="60" cy="60" r="60" fill="#039BE5"/>
                            <path fill="#FFF" d="M27.455 58.7l57.85-22.305c2.685-.97 5.03.655 4.16 4.715l.005-.005-9.85 46.405c-.73 3.29-2.685 4.09-5.42 2.54l-15-11.055-7.235 6.97c-.8.8-1.475 1.475-3.025 1.475l1.065-15.265 27.8-25.115c1.21-1.065-.27-1.665-1.865-.605l-34.355 21.63-14.81-4.62c-3.215-1.02-3.285-3.215.68-4.765z"/>
                        </g>
                    </g>
                </g>
            </g>
          </g>
        </svg>

        <h3 dangerouslySetInnerHTML={{__html: i18n.t("modal_title")}} />
        <p dangerouslySetInnerHTML={{__html: i18n.t("modal_message")}} />

        <button className="btn-upload-foto" children={i18n.t("modal_button")} onClick={() => this.dismiss()} />
      </div>
    </div>;
  }

}
